import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import objectAssign from 'object-assign';
import Region from './Region';
import { style } from './style';

export default class RegionSelect extends Component {
  constructor(props) {
    super(props);
    this.onDocMouseTouchMove = this.onDocMouseTouchMove.bind(this);
    this.onDocMouseTouchEnd = this.onDocMouseTouchEnd.bind(this);
    this.onRegionMoveStart = this.onRegionMoveStart.bind(this);
    this.onMouseClick = this.onMouseClick.bind(this);
    this.regionCounter = 0;
  }
  imageRef = React.createRef();

  componentDidMount() {
    document.addEventListener('mousemove', this.onDocMouseTouchMove);
    document.addEventListener('touchmove', this.onDocMouseTouchMove);

    document.addEventListener('mouseup', this.onDocMouseTouchEnd);
    document.addEventListener('touchend', this.onDocMouseTouchEnd);
    document.addEventListener('touchcancel', this.onDocMouseTouchEnd);
  }
  componentWillUnmount() {
    document.removeEventListener('mousemove', this.onDocMouseTouchMove);
    document.removeEventListener('touchmove', this.onDocMouseTouchMove);

    document.removeEventListener('mouseup', this.onDocMouseTouchEnd);
    document.removeEventListener('touchend', this.onDocMouseTouchEnd);
    document.removeEventListener('touchcancel', this.onDocMouseTouchEnd);
  }
  getClientPos(e) {
    let pageX, pageY;

    if (e.touches) {
      pageX = e.touches[0].pageX;
      pageY = e.touches[0].pageY;
    } else {
      pageX = e.pageX;
      pageY = e.pageY;
    }

    return {
      x: pageX,
      y: pageY,
    };
  }
  onDocMouseTouchMove(event) {
    //Este es el método al que se llama cuando se mueve una región
    if (!this.isChanging) {
      return;
    }
    const index = this.regionChangeIndex;
    const updatingRegion = this.props.regions[index];

    if (!updatingRegion) {
      return;
    }

    const clientPos = this.getClientPos(event);
    const regionChangeData = this.regionChangeData;
    var updatedRegions = [];
    let x, y, width, height;
    if (!regionChangeData.isMove) {
      let x1Pc, y1Pc, x2Pc, y2Pc;
      x1Pc =
        ((regionChangeData.clientPosXStart - regionChangeData.imageOffsetLeft) /
          regionChangeData.imageWidth) *
        100;
      y1Pc =
        ((regionChangeData.clientPosYStart - regionChangeData.imageOffsetTop) /
          regionChangeData.imageHeight) *
        100;
      x2Pc =
        ((clientPos.x - regionChangeData.imageOffsetLeft) /
          regionChangeData.imageWidth) *
        100;
      y2Pc =
        ((clientPos.y - regionChangeData.imageOffsetTop) /
          regionChangeData.imageHeight) *
        100;
      x = Math.min(x1Pc, x2Pc);
      y = Math.min(y1Pc, y2Pc);
      width = Math.abs(x1Pc - x2Pc);
      height = Math.abs(y1Pc - y2Pc);
      if (this.props.constraint) {
        if (x2Pc >= 100) {
          x = x1Pc;
          width = 100 - x1Pc;
        }
        if (y2Pc >= 100) {
          y = y1Pc;
          height = 100 - y1Pc;
        }
        if (x2Pc <= 0) {
          x = 0;
          width = x1Pc;
        }
        if (y2Pc <= 0) {
          y = 0;
          height = y1Pc;
        }
      }
      const rect = {
        x: x,
        y: y,
        width: width,
        height: height,
        isChanging: true,
      };

      this.props.onChange([
        ...this.props.regions.slice(0, index),
        objectAssign({}, updatingRegion, rect),
        ...this.props.regions.slice(index + 1),
      ]);
    } else {
      //Entra en esta parte del if cuando se ha movido la región, y no se ha cambiado su tamaño
      //A continuación se calcula la nueva posición de la región seleccionada (Código original de la librería)
      x =
        ((clientPos.x +
          regionChangeData.clientPosXOffset -
          regionChangeData.imageOffsetLeft) /
          regionChangeData.imageWidth) *
        100;
      y =
        ((clientPos.y +
          regionChangeData.clientPosYOffset -
          regionChangeData.imageOffsetTop) /
          regionChangeData.imageHeight) *
        100;
      width = updatingRegion.width;
      height = updatingRegion.height;
      if (this.props.constraint) {
        if (x + width >= 100) {
          x = Math.round(100 - width);
        }
        if (y + height >= 100) {
          y = Math.round(100 - height);
        }
        if (x <= 0) {
          x = 0;
        }
        if (y <= 0) {
          y = 0;
        }
      }
    }
    if (!this.props.moveAllRegions) {
      //Comprobamos si está marcada la opción de mover todas las regiones
      //Si no lo está, movemos la región seleccionado de forma normal
      const rect = {
        x: x,
        y: y,
        width: width,
        height: height,
        isChanging: true,
        reqUpdate: true,
      };

      this.props.onChange([
        ...this.props.regions.slice(0, index),
        objectAssign({}, updatingRegion, rect),
        ...this.props.regions.slice(index + 1),
      ]);
    } else {
      //Si la opción está marcada:
      //Calculamos cuánto se ha movido la región en cada dirección
      let change_x = updatingRegion.x - x;
      let change_y = updatingRegion.y - y;
      let block = false;
      for (let i = 0; i < this.props.regions.length; i++) {
        //Por cada región:
        if (i !== index) {
          let updatingRegionAux = this.props.regions[i];
          updatingRegionAux.x -= change_x;
          updatingRegionAux.y -= change_y;
          if (
            updatingRegionAux.x + updatingRegionAux.width > 100 ||
            updatingRegionAux.x < 0 ||
            updatingRegionAux.y + updatingRegionAux.height > 100 ||
            updatingRegionAux.y < 0
          )
            block = true;
          updatedRegions.push({ ...updatingRegionAux, reqUpdate: true }); //Movemos la región la misma distancia en cada dirección
        } else {
          //La región original no la modificamos, y la añadimos como está
          const rectAux = {
            x: x,
            y: y,
            width: width,
            height: height,
            isChanging: true,
            reqUpdate: true,
          };

          updatedRegions.push(objectAssign({}, updatingRegion, rectAux));
        }
      } //Consolidamos los cambios actualizando el array de regiones
      if (block) {
        for (let i = 0; i < updatedRegions.length; i++) {
          updatedRegions[i].x += change_x;
          updatedRegions[i].y += change_y;
        }
      }
      this.props.onChange(updatedRegions);
    }
  }
  onDocMouseTouchEnd() {
    if (this.isChanging) {
      this.isChanging = false;
      const index = this.regionChangeIndex;
      const updatingRegion = this.props.regions[index];
      if (updatingRegion) {
        const changes = {
          new: false,
          isChanging: false,
          justUpdated: updatingRegion.reqUpdate ? true : false,
          reqUpdate: false,
        };
        this.regionChangeIndex = null;
        this.regionChangeData = null;
        if (
          this.props.moveAllRegions &&
          !(this.props.regions.findIndex((x) => !x.data) >= 0)
        ) {
          const allRegions = this.props.regions.map((region) =>
            objectAssign({}, region, changes),
          );
          this.props.onChange(allRegions);
        } else {
          this.props.onChange([
            ...this.props.regions.slice(0, index),
            objectAssign({}, updatingRegion, changes),
            ...this.props.regions.slice(index + 1),
          ]);
        }
      }
      this.props.updateMoveAllRegions();
    }
  }
  getElementOffset(el) {
    const rect = el.getBoundingClientRect();
    const docEl = document.documentElement;

    const rectTop = rect.top + window.pageYOffset - docEl.clientTop;
    const rectLeft = rect.left + window.pageXOffset - docEl.clientLeft;

    return {
      top: rectTop,
      left: rectLeft,
    };
  }
  onMouseClick(event, index) {
    if (
      !(!event.target.dataset.wrapper && !event.target.dataset.dir) ||
      event.target.type === 'button' ||
      event.target.className === 'select-styled ' ||
      event.target.tagName === 'LI' ||
      event.target.className.includes('icon')
    ) {
      return;
    }
    this.props.setSelectedRegion('');
  }
  onRegionMoveStart(event, index) {
    if (!event.target.dataset.wrapper && !event.target.dataset.dir) {
      return;
    }
    const currentRegion = this.props.regions[index];

    if (this.props.selectedRegion !== currentRegion.data) {
      this.props.setSelectedRegion(currentRegion.data);
    }
    if (
      currentRegion.data !== this.props.unLockedRegion &&
      !this.props.moveAllRegions
    )
      return;
    event.preventDefault();

    const clientPos = this.getClientPos(event);
    const imageOffset = this.getElementOffset(this.imageRef.current);
    let clientPosXStart, clientPosYStart;

    const regionLeft =
      (currentRegion.x / 100) * this.imageRef.current.offsetWidth +
      imageOffset.left;
    const regionTop =
      (currentRegion.y / 100) * this.imageRef.current.offsetHeight +
      imageOffset.top;
    const regionWidth =
      (currentRegion.width / 100) * this.imageRef.current.offsetWidth;
    const regionHeight =
      (currentRegion.height / 100) * this.imageRef.current.offsetHeight;
    const clientPosDiffX = regionLeft - clientPos.x;
    const clientPosDiffY = regionTop - clientPos.y;
    const resizeDir = event.target.dataset.dir;
    if (resizeDir) {
      if (resizeDir === 'se') {
        clientPosXStart = regionLeft;
        clientPosYStart = regionTop;
      } else if (resizeDir === 'sw') {
        clientPosXStart = regionLeft + regionWidth;
        clientPosYStart = regionTop;
      } else if (resizeDir === 'nw') {
        clientPosXStart = regionLeft + regionWidth;
        clientPosYStart = regionTop + regionHeight;
      } else if (resizeDir === 'ne') {
        clientPosXStart = regionLeft;
        clientPosYStart = regionTop + regionHeight;
      }
    } else {
      clientPosXStart = clientPos.x;
      clientPosYStart = clientPos.y;
    }

    this.isChanging = true;
    this.regionChangeData = {
      imageOffsetLeft: imageOffset.left,
      imageOffsetTop: imageOffset.top,
      clientPosXStart: clientPosXStart,
      clientPosYStart: clientPosYStart,
      clientPosXOffset: clientPosDiffX,
      clientPosYOffset: clientPosDiffY,
      imageWidth: this.imageRef.current.offsetWidth,
      imageHeight: this.imageRef.current.offsetHeight,
      isMove: resizeDir ? false : true,
      resizeDir: resizeDir,
    };
    this.regionChangeIndex = index;
  }
  renderRect(rect, index) {
    return (
      <Region
        x={rect.x}
        y={rect.y}
        width={rect.width}
        height={rect.height}
        handles={!rect.new}
        data={rect.data}
        key={index}
        index={index}
        isVisible={rect.isVisible} //new
        dataRenderer={this.props.regionRenderer}
        onCropStart={(event) => this.onRegionMoveStart(event, index)}
        changing={index === this.regionChangeIndex}
        selectedRegion={this.props.selectedRegion}
        unLockedRegion={this.props.unLockedRegion}
        onClickLock={this.props.onClickLock}
        disableLock={this.props.disableLocks}
      />
    );
  }
  render() {
    const regions = this.props.regions;
    return (
      <div
        ref={this.imageRef}
        style={objectAssign({}, style.RegionSelect, this.props.style)}
        className={this.props.className}
        onMouseDown={this.onMouseClick}
      >
        {regions.map(this.renderRect.bind(this))}
        {this.props.children}
      </div>
    );
  }
}
RegionSelect.propTypes = {
  constraint: PropTypes.bool,
  moveAllRegions: PropTypes.bool,
  regions: PropTypes.array,
  children: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  regionRenderer: PropTypes.func,
  debug: PropTypes.bool,
  className: PropTypes.string,
  selectedRegion: PropTypes.string,
  setSelectedRegion: PropTypes.func.isRequired,
  unLockedRegion: PropTypes.string.isRequired,
  onClickLock: PropTypes.func.isRequired,
  updateMoveAllRegions: PropTypes.func.isRequired,
  disableLocks: PropTypes.bool,
  style: PropTypes.object,
};
RegionSelect.defaultProps = {
  debug: false,
  regions: [],
  constraint: false,
  moveAllRegions: false,
  disableLocks: false,
  className: '',
  style: {},
  regionRenderer: undefined,
  selectedRegion: undefined,
};
